<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>School Privacy Policy</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <AddPolicy @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div v-show="editshow" class="card-body">
            <PrivacyPolicyTable  :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrivacyPolicyTable from '@/components/schoolPrivacyPolicy/Table/index'
import AddPolicy from '@/components/schoolPrivacyPolicy/Forms/Add/index'

export default {
  components: {
    PrivacyPolicyTable,
    AddPolicy,
  },
  mounted: function() {
    this.getPolicy()
  },
  computed: {
    schoolId: function () {
      return this.$route.params.id
    },
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
      editshow: false,
    }
  },
  methods: {
    getPolicy: function() {
      this.loading = true
      this.$http.get(`/api/school-privacy-policy/${this.schoolId}`, {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = [data.data]
        this.meta = data.meta
        if (Object.keys(data.data).length === 0) {
          this.editshow = false
        } else {
          this.editshow = true
        }
      })
    },
    handleCreated: function() {
      this.getPolicy()
    },
    handleUpdateTable: function() {
      this.getPolicy()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getPolicy()
    },
    onChange(current) {
      this.current = current
      this.getPolicy()
    },
  },
}
</script>
